import { useApolloClient } from '@apollo/client';

import type { GetAssessmentAssignDataQuery } from '../../shared/assign/assign-assessment.graphql.generated';
import type { GetLessonAssignDataQuery } from '../../shared/assign/assign-lesson.graphql.generated';
import {
  ActivitiesContentType,
  ASSESSMENT_ACTIVITIES,
  LanguageCodes,
} from 'global/constants';
import type { Pluck } from 'lib/gql/pluck';

export const useUpdateActivityBookmarkData = ({
  id,
  language,
  version,
  contentType,
}: {
  id: number;
  language: LanguageCodes;
  version: string;
  contentType: ActivitiesContentType;
}) => {
  const client = useApolloClient();

  const updateBookmarkData = (
    assignedData:
      | Pluck<GetAssessmentAssignDataQuery, 'getAssessmentById.assignedData'>
      | Pluck<GetLessonAssignDataQuery, 'getLessonById.assignedData'>
      | null,
    isAssigned: boolean
  ) => {
    const isAssessment = contentType === ASSESSMENT_ACTIVITIES;
    const activityTypeName = isAssessment
      ? 'AssessmentActivities'
      : 'LessonActivities';
    const property = isAssessment ? 'assessment' : 'lesson';

    client.cache.modify({
      id: client.cache.identify({
        id,
        language,
        __typename: activityTypeName,
        version,
      }),
      fields: {
        [property]: existing => ({
          ...existing,
          assignedData,
          isAssigned,
        }),
      },
    });
  };

  return {
    updateBookmarkData,
  };
};
